import ButtonGroupSkeleton from '@/components/skeletons/ButtonGroupCustomized'
import CalendarSkeleton from '@/components/skeletons/Calendar'
import EventSkeleton from '@/components/skeletons/EventSkeleton'
import AddIcons from '@/icons/AddIcons'
import CreateEventForm from '@/modules/Events/components/Create'
import { getEventSummaryByWeek } from '@/modules/Events/components/services'
import { formatDateWithFormatter, startOf } from '@/utils/function'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog, IconButton, Typogaphy } from 'vnetwork-ui'
import Calendar from './Canlendar'
import Community from './Community'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface EventsProps {
    className?: string
}

const Events: React.FC<EventsProps> = () => {
    const { t } = useTranslation('dashboard')
    const [currentDate, setCurrentDate] = useState(new Date())
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [isCreateDrawerOpen, setIsCreateDrawerOpen] = useState(false)

    const { data: eventSummary, renderState } = useQueryWithHandler(
        {
            queryKey: [
                QUERY_KEYS.EVENTS_SUMMARY,
                startOf(dayjs(selectedDate), 'week'),
            ],
            queryFn: () =>
                getEventSummaryByWeek(startOf(dayjs(selectedDate), 'week')),
        },
        {
            errorDisplayMode: 'page',
        }
    )

    const handleCreateEvent = () => {
        setIsCreateDrawerOpen(true)
    }

    const handleCloseCreateDrawer = () => {
        setIsCreateDrawerOpen(false)
    }

    const stateComponent = renderState()
    if (stateComponent)
        return (
            <>
                <CalendarSkeleton />
                <ButtonGroupSkeleton length={2} />
                <EventSkeleton />
            </>
        )

    return (
        <div className="">
            <div>
                <div className="flex items-center justify-between mb-4">
                    <Typogaphy className="font-semibold text-primary">
                        {t('events.title')}
                    </Typogaphy>
                    <IconButton
                        size="small"
                        className="text-primary text-xs p-2 hover:bg-blue-50 transition-colors"
                        onClick={handleCreateEvent}
                    >
                        <AddIcons className="w-4 h-4 font-medium" />
                    </IconButton>
                </div>

                <Calendar
                    eventSummary={eventSummary?.result}
                    currentDate={currentDate}
                    setCurrentDate={setCurrentDate}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                />

                <div className="mt-2">
                    <Community
                        date={formatDateWithFormatter(
                            dayjs(selectedDate),
                            'YYYY-MM-DD'
                        )}
                    />
                </div>
            </div>

            {/* Create Event Drawer */}
            {/* <Modal isOpen={isCreateDrawerOpen} onClose={handleCloseCreateDrawer}> */}
            <Dialog
                open={isCreateDrawerOpen}
                onClose={handleCloseCreateDrawer}
                maxWidth="sm"
            >
                <CreateEventForm
                    onClose={handleCloseCreateDrawer}
                    initialDate={selectedDate}
                />
            </Dialog>
            {/* </Modal> */}
        </div>
    )
}

export default Events
